import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import ApplicationDetailsPage from './ApplicationDetailsPage';

const ApplicationOverviewRouter = () => (
    <Routes >
        <Route path="application/:applicationId/" element={<ApplicationDetailsPage />} />
        <Route path="container/:containerId/" element={<ApplicationDetailsPage />} />

        <Route
            path="*"
            element={<Navigate to="/404" replace />}
        />
    </Routes>
);

ApplicationOverviewRouter.displayName = 'Router';

export default ApplicationOverviewRouter;
